export default "__VITE_ASSET__e791165b__"